module.exports = __webpack_public_path__ + "assets/svg/Icons/32/user-gray-db35e7.svg";